import { Fragment, ReactElement, useEffect } from 'react'

import styled from 'styled-components'
import { ProductModel } from 'interfaces'
import { breakpoints } from '../../../../../../src/theme/breakpoints'
import { ProductCard } from '../ProductCard'
import { observer } from 'mobx-react-lite'
import { useResultsStore } from '../../../store/ResultsStore'

interface Props {
  parts: ProductModel[]
}

const ResultsTable = observer((props: Props): ReactElement => {
  const { parts } = props

  const resultsStore = useResultsStore()
  const { gfxLookupMade, searchResults } = resultsStore

  const { totalCount, filteredCount, isSnwFinished } = searchResults

  function isProductGreen(index: number): boolean {
    return Boolean(
      parts[index]?.isGfx && parts[index]?.gfxPartGreen && gfxLookupMade
    )
  }

  useEffect(() => {
    let fetchPartsTimeout: ReturnType<typeof setTimeout>
    let fetchPartsInterval: ReturnType<typeof setTimeout>
    if (
      filteredCount < totalCount &&
      !isSnwFinished &&
      resultsStore.filters.length === 0
    ) {
      fetchPartsInterval = setInterval(() => {
        if (!isSnwFinished) {
          resultsStore.searchByPartBin()
        } else {
          clearInterval(fetchPartsInterval)
        }
      }, 5000)

      // Stop the interval after reaching a max threshold (i.e 5 times)
      fetchPartsTimeout = setTimeout(() => {
        clearInterval(fetchPartsInterval)
      }, 25000)
    }
    // clear the timer when component unmouts
    return () => {
      clearInterval(fetchPartsInterval)
      clearTimeout(fetchPartsTimeout)
    }
  }, [filteredCount, isSnwFinished, resultsStore, totalCount])

  return (
    <Table>
      <tbody>
        {parts.map((product: ProductModel, index) => (
          <Fragment key={product.partNumber + product.lineNo}>
            <ProductCard
              key={product.partNumber + product.lineNo + product.lineCode}
              product={product}
              green={isProductGreen(index)}
            />
            {product?.alternateParts?.map((alternatePart, indexAlternate) => (
              <ProductCard
                key={`${product.partNumber + product.lineNo + indexAlternate}a`}
                product={alternatePart}
                alternateFor={product}
                green={isProductGreen(index + indexAlternate)}
              />
            ))}
            {product?.replacementParts?.map(
              (replacementPart, indexReplacement) => (
                <ProductCard
                  key={`${
                    product.partNumber + product.lineNo + indexReplacement
                  }r`}
                  product={replacementPart}
                  replacementFor={product}
                  green={isProductGreen(index + indexReplacement)}
                />
              )
            )}
          </Fragment>
        ))}
      </tbody>
    </Table>
  )
})

const Table = styled.table`
  width: 100%;

  @media screen and (min-width: ${breakpoints.tablet}px) and (max-width: ${breakpoints.laptopMedium -
    1}px) {
    width: max-content;
    min-width: 100%;
  }
`

export default ResultsTable
